import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP } from "app/auth/baseAsap";
import moment from "moment";
import constants from "@tracking/utils/constants";

const { DATE_FORMAT } = constants;

const parseGetFiliaisTransportadoras = (params) => {
  return {
    dataInicial: moment(params.dataInicial).format(DATE_FORMAT.API),
    dataFinal: moment(params.dataFinal).format(DATE_FORMAT.API),
    tipoRoteiros: params.tipoRoteiros,
    tipoOperacao: "DIRETO",
    etapa: params.etapa,
  };
};

const parseGetRoteirosAlertas = (params) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasIds: params.transportadorasIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    tipoRoteiros: params.tipoRoteiros,
    etapa: params.etapa,
  };
};

const parseGetRoteirosCriticidade = (params: any) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasIds: params.transportadorasIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    tipoCriticidade: params.tipoCriticidade,
    tipoRoteiros: params.tipoRoteiros,
    etapa: params.etapa,
  };
};

export const getFiliaisTransportadoras = createAsyncThunk(
  "torrePesadosApp/torrePesados/getFiliaisTransportadoras",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get(
        "/dashboard/roteiros/pedidos/filiaisetransportadoras",
        {
          params: parseGetFiliaisTransportadoras(params),
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraDiaEvolucao = createAsyncThunk(
  "torrePesadosApp/torrePesados/getSafraDiaEvolucao",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get("/dashboard/safra/dia/DIRETO/evolucao", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraPlanejada = createAsyncThunk(
  "torrePesadosApp/torrePesados/getSafraPlanejada",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get("/dashboard/safra/dia/DIRETO/planejado", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosAlertas = createAsyncThunk(
  "torrePesadosApp/torrePesados/getRoteirosAlertas",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get("/dashboard/roteiros/DIRETO/alertas", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosCriticidade = createAsyncThunk(
  "torrePesadosApp/torrePesados/getRoteirosCriticidade",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP.get("/dashboard/roteiros/DIRETO/criticidades", {
        params: parseGetRoteirosCriticidade(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);
